import InlineSVG from '@boilerplates/inlineSvg'
import Image from '@components/Image'
import { ElementHTML } from '@helpers/helper.rendering'
import React, { useEffect, useState } from 'react'
import { RealEstateDataPageComponentData } from 'types'
import $ from 'jquery'

const Hero_8 = (props: RealEstateDataPageComponentData) => {
  const {
    image_gatsby,
    height,
    opacityValue,
    title,
    titleElement,
    titleHexa,
    image_right,
    animationStyle,
  } = props

  const scrollPage = () => {
    if (typeof window !== `undefined`) {
      var body = $('html, body')
      return body.stop().animate({ scrollTop: window.innerHeight }, 500, 'swing', function () {})
    }
  }
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  const getHeight = (): string => {
    const isMobile = isMounted && window.innerWidth <= 992
    if (!height) {
      return '100vh'
    }
    const baseHeight = isMobile ? height.mobile : height.desktop
    return height.scalePixels ? `${baseHeight}px` : `${baseHeight}vh`
  }

  return (
    <section
      id="hero"
      className="hero-8"
    >
      {opacityValue && opacityValue !== '0' ? (
        <div
          className="opacity-layer"
          style={{
            opacity:
              opacityValue && opacityValue !== '0'
                ? Number(opacityValue) !== 100
                  ? `0.${Number(opacityValue)}`
                  : 1
                : 0,
          }}
        ></div>
      ) : null}
      {image_gatsby && (
        <Image
          image={image_gatsby}
          objectFit="cover"
          alt="hero-img"
          className="w-100"
          style={{
            height: getHeight(),
          }}
          objectPosition="center"
        />
      )}
      {title && (
        <ElementHTML
          children={title}
          elementType={titleElement ?? 'h1'}
          className={`hero-title ${animationStyle ? animationStyle : 'no-animation'}`}
          style={titleHexa ? { color: titleHexa } : {}}
        />
      )}
      {image_right && (
        <InlineSVG
          src={image_right}
          className="scroll-down-icon d-flex justify-content-center slide-down"
          onClick={() => scrollPage()}
        />
      )}
    </section>
  )
}

export default Hero_8
